module.exports = __webpack_public_path__ + "img/facebook.ebb754ba.svg";